import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../../modules/infra/i18n';

const WaiverViewLink = ({ appointment }) => (
  <a
    target="_blank"
    rel="noopener noreferrer"
    href={appointment.waiverViewLink}
    className="c-btn"
  >
    {t('appointment:actions.view_waiver')}
  </a>
);

WaiverViewLink.propTypes = {
  appointment: PropTypes.shape({
    waiverViewLink: PropTypes.string.isRequired,
  }).isRequired,
};

export default WaiverViewLink;
